module.exports = __webpack_public_path__ + "img/21.3227d12f.gif";